const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "User",
    dataIndex: "userDetails",
  },
  {
    title: "Account Type",
    dataIndex: "accountType",
    render: defaultRender,
  },
  {
    title: "Account No.",
    dataIndex: "login",
    render: defaultRender,
  },
  {
    title: "Error Message",
    dataIndex: "errorMessage",
    render: defaultRender,
  },
];

export default columns;
